import { render, staticRenderFns } from "./BankAccountsTab.vue?vue&type=template&id=b17d6e78"
import script from "./BankAccountsTab.vue?vue&type=script&lang=js"
export * from "./BankAccountsTab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports